module.exports = __webpack_public_path__ + "seek-icon-logo.png";